import { Injectable } from '@angular/core';
import { init as initApm, ApmBase } from '@elastic/apm-rum';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class ApmService {
  private apmInstance!: ApmBase;

  constructor(private configService: EnvironmentService) {}

  init() {
    const config = this.configService.getConfiguration();
    if (!config) {
      console.error('APM config is not available!');
      return;
    }

    this.apmInstance = initApm({
      serviceName: 'allcareUS-web-ui',
      serverUrl: config.APMServerURL,
      environment: config.environment,
      logLevel: 'error',
      transactionSampleRate: 1.0,
      distributedTracingOrigins: [window.location.origin],
      breakdownMetrics: true,
      centralConfig: false,

      // Disable auto instrumentation
      instrument: false,
      
    });
  }

  get apm(): ApmBase {
    if (!this.apmInstance) {
      throw new Error('APM is not initialized yet. Call init() first.');
    }
    return this.apmInstance;
  }
}
